import React from 'react';
import { useParams } from 'react-router-dom';
import { LineItem } from '../../../hooks/useCart/cart.rest';
import { hrefFor } from '../../../routers';
import { Link } from '../../Link';
import { Image } from '../../Image';
import './LineItemImage.scss';

type Props = {
  item: LineItem;
};

export const LineItemImage: React.FC<Props> = ({
  item: {
    attributes: { variantHref, variantId, imageSrc, productName }
  }
}) => {
  const { vertical = 'women' } = useParams();
  const [, designerSlug, productSlug] = variantHref.split('/');

  return (
    <Link
      to={hrefFor.ProductDetailPage({
        vertical,
        designerSlug,
        productSlug,
        variantId: String(variantId)
      })}
    >
      <Image
        className="LineItemImage__image"
        src={imageSrc}
        alt={productName}
        data-variant-pk={variantId}
      />
    </Link>
  );
};
